import { defineMessages } from '@atlassian/jira-intl';

export const messages = defineMessages({
	title: {
		id: 'backlog.modals.select-transitions-modal.title',
		defaultMessage: 'Choose a transition',
		description: '',
	},
	description: {
		id: 'backlog.modals.select-transitions-modal.description',
		defaultMessage: 'Choose one of {count} available transitions for issue {cardKeys}',
		description: '',
	},
	cancel: {
		id: 'backlog.modals.select-transitions-modal.cancel',
		defaultMessage: 'Cancel',
		description: '',
	},
	choose: {
		id: 'backlog.modals.select-transitions-modal.choose',
		defaultMessage: 'Choose',
		description: '',
	},
	descriptionIssueTermRefresh: {
		id: 'backlog.modals.select-transitions-modal.description-issue-term-refresh',
		defaultMessage: 'Choose one of {count} available transitions for issue {cardKeys}',
		description: '',
	},
});
